// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__Xw-88","action":"styles_action__1CroC","territory":"styles_territory__3DKfW","name":"styles_name__2SMem"};